(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["klaviyo-quiz-popup"] && !Shopify.designMode) return;
  try {
    
(function () {
  var INSTANCE_KEY = '__kvQuizPopupInstance';
  var onKeyDownGlobal = null;

  function init(root) {
    if (!root || root[INSTANCE_KEY]) return;
    root[INSTANCE_KEY] = true;

    var delay         = parseInt(root.dataset.delay, 10) || 4000;
    var freqDays      = parseInt(root.dataset.frequencyDays, 10) || 7;
    var storageKey    = root.dataset.storageKey || 'jerms_klaviyo_quiz_popup_v1';
    var showOnMobile  = root.dataset.showOnMobile === 'true';
    var previewInEditor = root.dataset.previewInEditor === 'true';
    var designMode    = root.dataset.designMode === 'true' || !!(window.Shopify && window.Shopify.designMode);
    var freqMs        = freqDays * 24 * 60 * 60 * 1000;

    var dialog       = root.querySelector('.kv-quiz-popup__dialog');
    var closeButtons = root.querySelectorAll('[data-kv-close]');
    var overlay      = root.querySelector('[data-kv-overlay]');

    var lastFocused = null;

    function shouldShow() {
      if (designMode) return previewInEditor;
      if (!showOnMobile && window.matchMedia('(max-width: 768px)').matches) return false;
      try {
        var raw = window.localStorage.getItem(storageKey);
        if (!raw) return true;
        var stored = JSON.parse(raw);
        // Successful sign-ups suppress the popup permanently.
        if (stored && stored.submitted) return false;
        if (stored && stored.nextShowAt && Date.now() < stored.nextShowAt) return false;
      } catch (e) {
        return true;
      }
      return true;
    }

    function persistDismissal(submitted) {
      if (designMode) return;
      try {
        var multiplier = submitted ? 4 : 1;
        window.localStorage.setItem(
          storageKey,
          JSON.stringify({
            dismissedAt: Date.now(),
            submitted: !!submitted,
            nextShowAt: Date.now() + freqMs * multiplier
          })
        );
      } catch (e) {}
    }

    function preloadImage() {
      return new Promise(function (resolve) {
        var img = root.querySelector('[data-kv-image]');
        if (!img) return resolve();
        if (img.complete && img.naturalWidth > 0) return resolve();
        var done = function () { resolve(); };
        img.addEventListener('load', done, { once: true });
        img.addEventListener('error', done, { once: true });
        // Hard cap so a slow/blocked image never holds the popup forever.
        window.setTimeout(done, 2500);
      });
    }

    function open() {
      if (!shouldShow()) return;
      preloadImage().then(function () {
        root.hidden = false;
        root.setAttribute('aria-hidden', 'false');
        requestAnimationFrame(function () {
          root.classList.add('is-open');
        });
        document.body.style.overflow = 'hidden';
        if (window.globalLenis && typeof window.globalLenis.stop === 'function') {
          window.globalLenis.stop();
        }
        lastFocused = document.activeElement;
        if (dialog) dialog.focus();
        onKeyDownGlobal = onKeyDown;
        document.addEventListener('keydown', onKeyDownGlobal);
      });
    }

    function close(submitted) {
      root.classList.remove('is-open');
      root.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      if (window.globalLenis && typeof window.globalLenis.start === 'function') {
        window.globalLenis.start();
      }
      if (onKeyDownGlobal) document.removeEventListener('keydown', onKeyDownGlobal);
      persistDismissal(!!submitted);
      if (lastFocused && typeof lastFocused.focus === 'function') {
        lastFocused.focus();
      }
      setTimeout(function () { if (!root.classList.contains('is-open')) root.hidden = true; }, 500);
    }

    function onKeyDown(e) {
      if (e.key === 'Escape') {
        e.preventDefault();
        close(false);
      }
    }

    closeButtons.forEach(function (btn) {
      btn.addEventListener('click', function () { close(false); });
    });

    if (overlay) {
      overlay.addEventListener('click', function () { close(false); });
    }

    bindQuiz(root, close, persistDismissal);

    if (designMode) {
      if (previewInEditor) open();
    } else {
      window.setTimeout(open, delay);
    }

    root.__kvQuizPopupOpen = open;
    root.__kvQuizPopupClose = close;
  }

  // Native quiz: capture answer on step 1, capture email on step 2,
  // POST to Klaviyo Client API (profile + subscription + event), then
  // show the success step and auto-close.
  function bindQuiz(root, close, persist) {
    var stepsEl = root.querySelector('[data-kv-steps]');
    if (!stepsEl) return;

    var companyId   = stepsEl.dataset.klaviyoCompanyId;
    var listId      = stepsEl.dataset.klaviyoListId;
    var source      = stepsEl.dataset.klaviyoSource || 'Klaviyo Quiz Popup';
    var metricName  = stepsEl.dataset.klaviyoMetric || 'Quiz Submitted';
    var propertyKey = stepsEl.dataset.klaviyoPropertyKey || 'quiz_answer';
    var revision    = '2024-10-15';

    var steps     = stepsEl.querySelectorAll('[data-kv-step]');
    var choices   = stepsEl.querySelectorAll('[data-kv-choice]');
    var form      = stepsEl.querySelector('[data-kv-form]');
    var emailEl   = stepsEl.querySelector('[data-kv-email]');
    var submitBtn = stepsEl.querySelector('[data-kv-submit]');
    var errorEl   = stepsEl.querySelector('[data-kv-error]');

    var state = { answer: null, href: null };

    function showStep(n) {
      steps.forEach(function (s) {
        var match = s.dataset.kvStep === String(n);
        s.hidden = !match;
        s.classList.toggle('is-active', match);
      });
    }

    choices.forEach(function (btn) {
      btn.addEventListener('click', function () {
        choices.forEach(function (b) { b.classList.remove('is-selected'); });
        btn.classList.add('is-selected');
        state.answer = btn.getAttribute('value') || btn.textContent.trim();
        state.href = btn.getAttribute('data-kv-href') || null;
        showStep(2);
        if (emailEl) {
          window.setTimeout(function () { emailEl.focus(); }, 250);
        }
      });
    });

    function setError(msg) {
      if (!errorEl) return;
      if (msg) {
        errorEl.textContent = msg;
        errorEl.hidden = false;
      } else {
        errorEl.textContent = '';
        errorEl.hidden = true;
      }
    }

    function postJSON(url, body) {
      return fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'revision': revision
        },
        body: JSON.stringify(body)
      });
    }

    function submitToKlaviyo(email, answer) {
      if (!companyId) {
        return Promise.reject(new Error('Klaviyo company ID is not configured.'));
      }
      var qs = '?company_id=' + encodeURIComponent(companyId);
      var props = {};
      props[propertyKey] = answer;

      var profileBody = {
        data: {
          type: 'profile',
          attributes: { email: email, properties: props }
        }
      };

      var eventBody = {
        data: {
          type: 'event',
          attributes: {
            properties: props,
            metric: { data: { type: 'metric', attributes: { name: metricName } } },
            profile: { data: { type: 'profile', attributes: { email: email, properties: props } } }
          }
        }
      };

      var calls = [
        postJSON('https://a.klaviyo.com/client/profiles/' + qs, profileBody),
        postJSON('https://a.klaviyo.com/client/events/' + qs, eventBody)
      ];

      if (listId) {
        var subBody = {
          data: {
            type: 'subscription',
            attributes: {
              custom_source: source,
              profile: {
                data: {
                  type: 'profile',
                  attributes: {
                    email: email,
                    properties: props
                  }
                }
              }
            },
            relationships: { list: { data: { type: 'list', id: listId } } }
          }
        };
        calls.push(postJSON('https://a.klaviyo.com/client/subscriptions/' + qs, subBody));
      }

      return Promise.all(calls).then(function (responses) {
        // Klaviyo returns 202 for accepted requests, 2xx generally fine.
        var failed = responses.filter(function (r) { return !r.ok && r.status !== 202; });
        if (failed.length) {
          return failed[0].text().then(function (txt) {
            throw new Error(txt || ('Klaviyo error ' + failed[0].status));
          });
        }
        return true;
      });
    }

    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        setError('');
        var email = emailEl ? emailEl.value.trim() : '';
        if (!email || !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) {
          setError('Please enter a valid email address.');
          if (emailEl) emailEl.focus();
          return;
        }
        if (!state.answer) {
          setError('Please pick an answer first.');
          showStep(1);
          return;
        }

        if (submitBtn) {
          submitBtn.setAttribute('aria-busy', 'true');
          submitBtn.disabled = true;
        }

        submitToKlaviyo(email, state.answer)
          .then(function () {
            // Mark as submitted immediately so even if the redirect kicks
            // in before close() runs, the popup is suppressed on return.
            if (typeof persist === 'function') persist(true);
            showStep(3);
            var redirectMs = 1500;
            if (state.href) {
              window.setTimeout(function () { window.location.assign(state.href); }, redirectMs);
            } else {
              window.setTimeout(function () { close(true); }, 2500);
            }
          })
          .catch(function (err) {
            setError((err && err.message) ? err.message : 'Something went wrong. Please try again.');
          })
          .then(function () {
            if (submitBtn) {
              submitBtn.removeAttribute('aria-busy');
              submitBtn.disabled = false;
            }
          });
      });
    }
  }

  function findRoot(scope) {
    return (scope || document).querySelector('[data-kv-quiz-popup]');
  }

  function reopenIfDesignMode() {
    if (!(window.Shopify && window.Shopify.designMode)) return;
    var root = findRoot();
    if (!root) return;
    if (root.dataset.previewInEditor !== 'true') return;
    if (typeof root.__kvQuizPopupOpen === 'function') root.__kvQuizPopupOpen();
  }

  // Initial mount.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(findRoot()); });
  } else {
    init(findRoot());
  }

  // Klaviyo submit closes for everyone.
  document.addEventListener('klaviyoForms', function (e) {
    if (!e.detail || e.detail.type !== 'submit_success') return;
    var root = findRoot();
    if (!root) return;
    var btn = root.querySelector('[data-kv-close]');
    if (btn) btn.click();
  });

  // Theme Editor: re-init on section reload, and reopen when merchant
  // selects/changes settings on this section so the popup stays visible
  // through their edits.
  document.addEventListener('shopify:section:load', function (e) {
    init(findRoot(e.target));
    reopenIfDesignMode();
  });
  document.addEventListener('shopify:section:select', function () { reopenIfDesignMode(); });
  document.addEventListener('shopify:section:deselect', function () { reopenIfDesignMode(); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["minimal-announcement-bar"]) return;
  try {
    
  (function () {
    function initAnnouncementCtaScroll() {
      var bar = document.getElementById('minimal-announcement-bar');
      var cta = document.getElementById('gut-pdp');
      if (!bar || !cta) return;

      var prefersReduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      bar.addEventListener('click', function () {
        cta.scrollIntoView({ behavior: prefersReduce ? 'auto' : 'smooth', block: 'start' });
      });

      function setBarFromEntry(entry) {
        if (entry.isIntersecting) {
          bar.classList.add('announcement-bar--concealed');
        } else {
          bar.classList.remove('announcement-bar--concealed');
        }
      }

      if (!('IntersectionObserver' in window)) {
        function syncBarFallback() {
          var vh = window.innerHeight || document.documentElement.clientHeight;
          var r = cta.getBoundingClientRect();
          var anyVisible = r.bottom > 0 && r.top < vh;
          bar.classList.toggle('announcement-bar--concealed', anyVisible);
        }
        window.addEventListener('scroll', syncBarFallback, { passive: true });
        window.addEventListener('resize', syncBarFallback, { passive: true });
        syncBarFallback();
        return;
      }

      /*
        * threshold must include 0: with a tall CTA (100dvh), a thin strip visible can be <12% of the
        * element’s height — threshold 0.12 never fires, so the bar never hides.
        */
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(setBarFromEntry);
        },
        { threshold: 0 }
      );
      io.observe(cta);
    }

    if (document.readyState === 'complete') {
      initAnnouncementCtaScroll();
    } else {
      window.addEventListener('load', initAnnouncementCtaScroll);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-sticky-atc"]) return;
  try {
    
  (function () {
    function initStickyAtc() {
      var bar = document.querySelector('[data-pdp-sticky-atc]');
      var card = document.querySelector('[data-pdp-buy-card]');
      if (!bar || !card) return;

      var opts = bar.querySelectorAll('[data-sa-opt]');
      var radios = bar.querySelectorAll('[data-sa-radio]');
      var cta = bar.querySelector('[data-sa-cta]');
      var badge = bar.querySelector('[data-sa-badge]');
      var prefersReduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var currentOpt = 'subscribe';

      var mainSubRadio = card.querySelector('[data-buy-radio="subscribe"]');
      var mainOneRadio = card.querySelector('[data-buy-radio="onetime"]');
      var mainSubOpt = card.querySelector('.pdp-buy-card__option--subscribe');
      var mainOneOpt = card.querySelector('[data-buy-option="onetime"]');
      var mainFormSub = card.querySelector('[data-buy-form="subscribe"]');
      var mainFormOne = card.querySelector('[data-buy-form="onetime"]');

      function syncMainState(value) {
        // Mirror selectMode() in pdp-buy-button.liquid without firing change
        // (firing change triggers the main card's scrollTo, which jumps the
        // page when the user toggles from the sticky bar).
        var isOne = value === 'onetime';

        // The main card is off-screen when the sticky bar is in use. Toggling its
        // mode changes its height (form swap + max-height). When the card sits
        // ABOVE the viewport, that height change shifts all content below it, and
        // because Lenis holds its scroll target in document coords (it doesn't
        // honour native scroll-anchoring) the page jumps. We therefore:
        //   1. suppress the 0.4s height transition so the change is instant, then
        //   2. measure the height delta and compensate the scroll position so the
        //      viewport stays exactly where it was.
        var rectBefore = card.getBoundingClientRect();
        var scrollYBefore = window.pageYOffset || window.scrollY || 0;

        card.classList.add('is-sticky-syncing');
        if (mainSubRadio) mainSubRadio.checked = !isOne;
        if (mainOneRadio) mainOneRadio.checked = isOne;
        if (mainSubOpt) mainSubOpt.classList.toggle('is-selected', !isOne);
        if (mainOneOpt) {
          mainOneOpt.classList.toggle('is-selected', isOne);
          mainOneOpt.classList.toggle('is-open', isOne);
        }
        if (mainFormSub) mainFormSub.hidden = isOne;
        if (mainFormOne) mainFormOne.hidden = !isOne;

        // Force synchronous reflow to get the final (instant) height.
        var rectAfter = card.getBoundingClientRect();

        // Only compensate when the card is entirely above the viewport — that's
        // the only case where its height change moves the visible content.
        if (rectBefore.bottom <= 0) {
          var delta = rectAfter.height - rectBefore.height;
          if (delta) {
            var newY = scrollYBefore + delta;
            if (newY < 0) newY = 0;
            if (window.globalLenis && typeof window.globalLenis.scrollTo === 'function') {
              window.globalLenis.scrollTo(newY, { immediate: true });
            } else {
              window.scrollTo(0, newY);
            }
          }
        }

        requestAnimationFrame(function () {
          card.classList.remove('is-sticky-syncing');
        });
      }

      function selectOpt(value) {
        currentOpt = value;
        opts.forEach(function (o) {
          o.classList.toggle('is-selected', o.dataset.saOpt === value);
        });
        radios.forEach(function (r) {
          r.checked = r.dataset.saRadio === value;
        });
        syncMainState(value);
        if (badge) {
          badge.classList.toggle('is-hidden', value !== 'subscribe');
        }
      }

      opts.forEach(function (o) {
        o.addEventListener('click', function () {
          selectOpt(o.dataset.saOpt);
        });
      });

      cta.addEventListener('click', function () {
        var form = card.querySelector('[data-buy-form="' + currentOpt + '"]');
        var btn = card.querySelector('[data-buy-cta="' + currentOpt + '"]');
        if (btn) {
          btn.click();
          return;
        }
        if (form) {
          form.submit();
        }
      });

      function headerOffset() {
        var hdr =
          document.querySelector('.header-wrapper') ||
          document.querySelector('header[role="banner"]') ||
          document.querySelector('header');
        return hdr ? hdr.getBoundingClientRect().height : 0;
      }

      if (badge) {
        badge.addEventListener('click', function (e) {
          var target = document.getElementById('pdp-gifts') || card;
          if (!target) return;
          e.preventDefault();
          var offset = headerOffset() + 12;
          if (window.globalLenis && typeof window.globalLenis.scrollTo === 'function') {
            window.globalLenis.scrollTo(target, { offset: -offset });
          } else {
            var y = target.getBoundingClientRect().top + (window.pageYOffset || window.scrollY || 0) - offset;
            window.scrollTo({ top: y, behavior: prefersReduce ? 'auto' : 'smooth' });
          }
        });
      }

      function setStuck(stuck) {
        bar.classList.toggle('is-stuck', stuck);
      }

      if (!('IntersectionObserver' in window)) {
        function syncFallback() {
          var vh = window.innerHeight || document.documentElement.clientHeight;
          var r = card.getBoundingClientRect();
          var visible = r.bottom > 0 && r.top < vh;
          setStuck(!visible);
        }
        window.addEventListener('scroll', syncFallback, { passive: true });
        window.addEventListener('resize', syncFallback, { passive: true });
        syncFallback();
        return;
      }

      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          setStuck(!e.isIntersecting);
        });
      }, { threshold: 0 });
      io.observe(card);
    }

    if (document.readyState === 'complete') {
      initStickyAtc();
    } else {
      window.addEventListener('load', initStickyAtc);
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
